"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bold = bold;
exports.color = color;
exports.replaceUmlaute = replaceUmlaute;
exports.underline = underline;
function bold(text, selectionStart, selectionEnd) {
  var markedText = mark(text, selectionStart, selectionEnd, '*');
  return markedText;
}
function underline(text, selectionStart, selectionEnd) {
  var markedText = mark(text, selectionStart, selectionEnd, '_');
  return markedText;
}
function color(text, selectionStart, selectionEnd) {
  var markedText = mark(text, selectionStart, selectionEnd, '~');
  return markedText;
}
function mark(text, selectionStart, selectionEnd, chr) {
  var length = text.length;
  var start = selectionStart;
  var finish = selectionEnd;
  var prefix = text.substring(0, start);
  var suffix = text.substring(finish, length);
  var selection = text.substring(start, finish);
  var markedText = prefix + chr + selection + chr + suffix;
  return markedText;
}
var umlautMap = {
  Ü: 'UE',
  Ä: 'AE',
  Ö: 'OE',
  ü: 'ue',
  ä: 'ae',
  ö: 'oe',
  ß: 'ss'
};
function replaceUmlaute(str) {
  return str.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, function (a) {
    var bigUmlaut = umlautMap[a.slice(0, 1)];
    return bigUmlaut.charAt(0) + bigUmlaut.charAt(1).toLowerCase() + a.slice(1);
  }).replace(new RegExp("[".concat(Object.keys(umlautMap).join('|'), "]"), 'g'), function (a) {
    return umlautMap[a];
  });
}